// Budget-service and occasion vocabulary (#1289, #533 scope v2). No imports,
// so the SPA, edge functions, vitest and tsc all load the real module (same
// pattern as social-sync/mapping.ts). The SQL CHECK and set_social_post_tags()
// repeat these lists; social-enrich-migration.test.ts keeps them equal. Lead
// rows use them too (#1290): the events.budget_service / events.occasion
// CHECKs and lead_budget_service_from_text() in the
// *_add_events_budget_service_occasion migration (pinned by
// lead-budget-service-migration.test.ts), and meta-capi/lead-category.ts.
//
// Two layers: a budget service is a quote-form funnel with its own ad set and
// budget floor. An occasion is a detail tag for copy matching and gap alerts,
// and never drives budget.

/** The quote-form funnels the ad budget is split by (Frank, 2026-10-10). */
export const BUDGET_SERVICES = ["drop_off", "live_service", "corporate", "wedding", "event_space"] as const;
export type BudgetService = (typeof BUDGET_SERVICES)[number];

/** A brand post that sells no one service. Only ever a primary service, never in `services`. */
export const GENERAL_SERVICE = "general" as const;
export const PRIMARY_SERVICES = [...BUDGET_SERVICES, GENERAL_SERVICE] as const;
export type PrimaryService = (typeof PRIMARY_SERVICES)[number];

export const BUDGET_SERVICE_LABELS: Record<BudgetService, string> = {
  drop_off: "Drop-off",
  live_service: "Live service",
  corporate: "Corporate",
  wedding: "Wedding",
  event_space: "Event space",
};

export const PRIMARY_SERVICE_LABELS: Record<PrimaryService, string> = {
  ...BUDGET_SERVICE_LABELS,
  general: "General",
};

/** The quote form's `/plan?service=` value for each budget service. */
export const BUDGET_SERVICE_PLAN_PARAM: Record<BudgetService, string> = {
  drop_off: "drop_off",
  live_service: "live_service",
  corporate: "corporate",
  wedding: "wedding",
  event_space: "venue",
};

/** The budget service behind a `/plan?service=` value, or null when there isn't one. */
export function budgetServiceFromPlanParam(param: string | null): BudgetService | null {
  if (param === null) return null;
  return BUDGET_SERVICES.find((service) => BUDGET_SERVICE_PLAN_PARAM[service] === param) ?? null;
}

export const OCCASIONS = [
  "baptism",
  "communion",
  "birthday",
  "shower",
  "engagement",
  "wedding",
  "anniversary",
  "graduation",
  "retirement",
  "holiday_party",
  "corporate_lunch",
  "gala",
  "celebration_of_life",
  "other",
  "none",
] as const;
export type Occasion = (typeof OCCASIONS)[number];

export const OCCASION_LABELS: Record<Occasion, string> = {
  baptism: "Baptism",
  communion: "Communion",
  birthday: "Birthday",
  shower: "Shower",
  engagement: "Engagement",
  wedding: "Wedding",
  anniversary: "Anniversary",
  graduation: "Graduation",
  retirement: "Retirement",
  holiday_party: "Holiday party",
  corporate_lunch: "Corporate lunch",
  gala: "Gala",
  celebration_of_life: "Celebration of life",
  other: "Other",
  none: "None",
};
